import React, {useEffect, useState} from 'react';
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Button,
    Form,
    Alert,
    Spinner
} from 'reactstrap';

import {useSelector, useDispatch} from "react-redux";

import {Link} from "react-router-dom";
import withRouter from "../common/withRouter";
import * as Yup from "yup";
import {useFormik} from "formik";
import {
    deviceRegister,
    recordActivity
} from '../slices/register'

const getDevice = () => {
    let unknown = '-';

    // browser
    let nVer = navigator.appVersion;
    let nAgt = navigator.userAgent;
    let browser = navigator.appName;
    let version = '' + parseFloat(nVer);
    let nameOffset, verOffset, ix;

    // Yandex Browser
    if ((verOffset = nAgt.indexOf('YaBrowser')) != -1) {
        browser = 'Yandex';
        version = nAgt.substring(verOffset + 10);
    }
    // Samsung Browser
    else if ((verOffset = nAgt.indexOf('SamsungBrowser')) != -1) {
        browser = 'Samsung';
        version = nAgt.substring(verOffset + 15);
    }
    // UC Browser
    else if ((verOffset = nAgt.indexOf('UCBrowser')) != -1) {
        browser = 'UC Browser';
        version = nAgt.substring(verOffset + 10);
    }
    // Opera Next
    else if ((verOffset = nAgt.indexOf('OPR')) != -1) {
        browser = 'Opera';
        version = nAgt.substring(verOffset + 4);
    }
    // Opera
    else if ((verOffset = nAgt.indexOf('Opera')) != -1) {
        browser = 'Opera';
        version = nAgt.substring(verOffset + 6);
        if ((verOffset = nAgt.indexOf('Version')) != -1) {
            version = nAgt.substring(verOffset + 8);
        }
    }
    // Legacy Edge
    else if ((verOffset = nAgt.indexOf('Edge')) != -1) {
        browser = 'Microsoft Legacy Edge';
        version = nAgt.substring(verOffset + 5);
    }
    // Edge (Chromium)
    else if ((verOffset = nAgt.indexOf('Edg')) != -1) {
        browser = 'Microsoft Edge';
        version = nAgt.substring(verOffset + 4);
    }
    // MSIE
    else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
        browser = 'Microsoft Internet Explorer';
        version = nAgt.substring(verOffset + 5);
    }
    // Chrome
    else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
        browser = 'Chrome';
        version = nAgt.substring(verOffset + 7);
    }
    // Safari
    else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
        browser = 'Safari';
        version = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf('Version')) != -1) {
            version = nAgt.substring(verOffset + 8);
        }
    }
    // Firefox
    else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
        browser = 'Firefox';
        version = nAgt.substring(verOffset + 8);
    }
    // MSIE 11+
    else if (nAgt.indexOf('Trident/') != -1) {
        browser = 'Microsoft Internet Explorer';
        version = nAgt.substring(nAgt.indexOf('rv:') + 3);
    }
    // Other browsers
    else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
        browser = nAgt.substring(nameOffset, verOffset);
        version = nAgt.substring(verOffset + 1);
        if (browser.toLowerCase() == browser.toUpperCase()) {
            browser = navigator.appName;
        }
    }
    // trim the version string
    if ((ix = version.indexOf(';')) != -1) version = version.substring(0, ix);
    if ((ix = version.indexOf(' ')) != -1) version = version.substring(0, ix);
    if ((ix = version.indexOf(')')) != -1) version = version.substring(0, ix);

    let majorVersion = parseInt('' + version, 10);
    if (isNaN(majorVersion)) {
        version = '' + parseFloat(nVer);
        majorVersion = parseInt(nVer, 10);
    }

    // mobile version
    let mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer);

    // cookie
    let cookieEnabled = (navigator.cookieEnabled) ? true : false;

    if (typeof navigator.cookieEnabled == 'undefined' && !cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = (document.cookie.indexOf('testcookie') != -1) ? true : false;
    }

    // system
    let os = unknown;
    let clientStrings = [
        {s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/},
        {s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/},
        {s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/},
        {s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/},
        {s: 'Windows Vista', r: /Windows NT 6.0/},
        {s: 'Windows Server 2003', r: /Windows NT 5.2/},
        {s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/},
        {s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/},
        {s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/},
        {s: 'Windows 98', r: /(Windows 98|Win98)/},
        {s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/},
        {s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},
        {s: 'Windows CE', r: /Windows CE/},
        {s: 'Windows 3.11', r: /Win16/},
        {s: 'Android', r: /Android/},
        {s: 'Open BSD', r: /OpenBSD/},
        {s: 'Sun OS', r: /SunOS/},
        {s: 'Chrome OS', r: /CrOS/},
        {s: 'Linux', r: /(Linux|X11(?!.*CrOS))/},
        {s: 'iOS', r: /(iPhone|iPad|iPod)/},
        {s: 'Mac OS X', r: /Mac OS X/},
        {s: 'Mac OS', r: /(Mac OS|MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
        {s: 'QNX', r: /QNX/},
        {s: 'UNIX', r: /UNIX/},
        {s: 'BeOS', r: /BeOS/},
        {s: 'OS/2', r: /OS\/2/},
        {s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/}
    ];
    for (let id in clientStrings) {
        let cs = clientStrings[id];
        if (cs.r.test(nAgt)) {
            os = cs.s;
            break;
        }
    }

    let osVersion = unknown;
    let type = 'web'
    if (/Windows/.test(os)) {
        osVersion = /Windows (.*)/.exec(os)[1];
        os = 'Windows';
        type = 'windows'
    }

    switch (os) {
        case 'Mac OS':
        case 'Mac OS X':
            osVersion = /(?:Android|Mac OS|Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh) ([\.\_\d]+)/.exec(nAgt)[1];
            break;
        case 'Android':
            osVersion = /(?:Android|Mac OS|Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh) ([\.\_\d]+)/.exec(nAgt)[1];
            type = 'android'
            break;

        case 'iOS':
            type = 'iphone'
            osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
            osVersion = osVersion[1] + '.' + osVersion[2] + '.' + (osVersion[3] | 0);
            break;
    }
    return {
        browser: browser,
        browserVersion: version,
        browserMajorVersion: majorVersion,
        mobile: mobile,
        os: os,
        osVersion: osVersion,
        cookies: cookieEnabled,
        type
    }
}

const Landing = (props) => {
    const dispatch = useDispatch();
    const [deviceReady, setDeviceReady] = useState(false);
    const {error, loading} = useSelector(state => ({
        ...state
    }));


    const userDevice = getDevice()
    console.log(userDevice)
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {},
        onSubmit: (values) => {
            props.router.navigate('/study-information')
        }
    });
    useEffect(() => {
        console.log('i fire once');
        const params = new URLSearchParams(props.router.location.search);
        let deviceId = sessionStorage.getItem('device') || undefined
        console.info('Device not found, registering new device.')
        if (!deviceId) {
            dispatch(deviceRegister({
                partner_id: params.get("partner_id"),
                model: "",
                type: userDevice.type,
                os: userDevice.os + " " + userDevice.osVersion
            }, (newDevice) => {
                dispatch(recordActivity(newDevice.id, {
                    action: "survey",
                    page_id: "0-1"
                }))
                if (newDevice.id) {
                    deviceId = newDevice.id
                    console.info('new device ID generated', newDevice.id)
                }
                if (deviceId === undefined) throw Error('Device ID busted')
                sessionStorage.setItem('device', deviceId)
                setDeviceReady(true)
            }))
        } else {
            dispatch(recordActivity(deviceId, {
                action: "survey",
                page_id: "0-1"
            }))
            setDeviceReady(true)
        }
    }, [dispatch])

    document.title = "Study Information";
    return (
        <React.Fragment>
            <div>
                <Container>
                    <Row className="pt-5 justify-content-center">
                        <Col className="p-0" xl={8} md={10} sm={12}>
                            <div className="text-center mt-2">
                                <h3>Telehealth for Problems with Opioid Use</h3>
                            </div>
                            <Card className="mt-4">
                                <CardBody className="p-4">
                                    {error && error ? (<Alert color="danger"> {error} </Alert>) : null}
                                    <Form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            validation.handleSubmit();
                                            return false;
                                        }}
                                        action="#">
                                        <Row className="justify-content-center">
                                            <Col className="pr-5 pl-5" xl={10} md={10} sm={12}>
                                                <div>
                                                    <p>Thank you for your interest in our research study.</p>
                                                    <p>We are studying whether an investigational telehealth platform can help people who are concerned about their opioid use connect to treatment.</p>
                                                    <p>If you are eligible and choose to participate, you will be assigned to one of two groups:</p>
                                                    <ul>
                                                        <li><strong>Telehealth platform group:</strong> You will receive access to an online investigational telehealth platform where you can chat with
                                                            a specially trained and supportive chatbot, connect
                                                            with a human recovery coach, and access treatment
                                                            with medication if desired.</li>
                                                        <li><strong>Referral group:</strong> You will not receive access to the
                                                            telehealth platform but will receive a list of referral
                                                            options and other information that is typically
                                                            provided to people concerned about their opioid use.</li>
                                                    </ul>
                                                    <p>All participants can earn up to $100 for taking part in the research study.</p>
                                                    <p>Click Study Information to learn more.</p>
                                                </div>
                                            </Col>
                                            <Col className="pr-5 pl-5" xl={5} md={6} sm={12}>
                                                <div className="mt-4">
                                                    <Button aria-label={"study information"}
                                                            disabled={!deviceReady || (error ? null : loading ? true : false)}
                                                            className="btn button-primary w-100" type="submit">
                                                        {loading ? <Spinner size="sm"
                                                                            className='me-2'> Loading... </Spinner> : null}
                                                        Study Information
                                                    </Button>
                                                </div>
                                                <br/>

                                            </Col>
                                        </Row>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default withRouter(Landing);
